module.exports = __webpack_public_path__ + "static/media/08-d-calendar.08a16a92.png";